import React, { useEffect, useState } from "react";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Clear } from "@mui/icons-material";
import "./CommonDateRangePicker.scss";

export default function DateTab(props) {
  // Calculate yesterday
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const today = new Date();

  const [value, setValue] = useState(null);
  const [dateValue, setDatevalue] = useState([]);
  const [warning, setWarning] = useState("");

  // Set default dates when component mounts
  useEffect(() => {
    if (!props?.dateFrom) {
      const defaultDates = [yesterday, today];
      setValue(defaultDates);
      setDatevalue(defaultDates);
      // Call onSelectDateRange with default dates
      props?.onSelectDateRange && props?.onSelectDateRange(defaultDates);
    }
  }, []);

  useEffect(() => {
    if (props?.dateFrom && props?.dateTo) {
      setValue([props?.dateFrom, props?.dateTo]);
    }
  }, [props?.dateFrom, props?.dateTo]);

  function daysToMonths(days, useAverage = false) {
  const daysPerMonth = useAverage ? 30.44 : 30; // average or fixed 30 days
  return (days / daysPerMonth).toFixed(0); // keep 2 decimal places
 }

  const handleDateChange = (newValue) => {
    if (newValue === null) {
      setValue([null, null]);
      setWarning("");
      props?.onSelectDateRange?.(newValue);
    } else {
      const [start, end] = newValue;
  
      if (start && end && props?.maxAllowedDays) {
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
        if (diffDays > props.maxAllowedDays) {
          setWarning(`⚠️ Max allowed duration is ${daysToMonths(props.maxAllowedDays)} Months`);
          return; // stop propagation
        } else {
          setWarning("");
        }
      }
  
      setValue(newValue);
      props?.onSelectDateRange?.(newValue);
    }
  };
  

  return (
    <>
      <DateRangePicker
        onChange={handleDateChange}
        value={value}
        format="d/MM/yy"
        className={`datePickerStyle ${!value?.[0] && "inActiveDatePickerStyle"}`}
        monthPlaceholder="MM"
        dayPlaceholder="DD"
        yearPlaceholder="YYYY"
        showLeadingZeros={false}
        clearIcon={null}
        calendarIcon={<CalendarMonthOutlinedIcon />}
        disabled={props?.disabled}
        minDate={props?.minDate}
        maxDate={props?.maxDate || null}
      />

      {props?.maxAllowedDays && warning && (
        <p className="text-red-500 text-sm mt-1">{warning}</p>
      )}
    </>
  );
}